import { render, staticRenderFns } from "./Crud.vue?vue&type=template&id=bbdbf81a&scoped=true"
import script from "./Crud.vue?vue&type=script&lang=js"
export * from "./Crud.vue?vue&type=script&lang=js"
import style0 from "./Crud.vue?vue&type=style&index=0&id=bbdbf81a&prod&scoped=true&lang=css"
import style1 from "./Crud.vue?vue&type=style&index=1&id=bbdbf81a&prod&lang=css"
import style2 from "./Crud.vue?vue&type=style&index=2&id=bbdbf81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdbf81a",
  null
  
)

export default component.exports